(function () {
    const checkCartForItems = () => {
        fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
                if (data.items.length > 0) {
                    document.querySelectorAll(".product-form__submit").forEach((button) => {
                        button.disabled = true;
                        button.title = "Cel puțin un articol este deja în coș";
                    });
                }
            })
            .catch((error) => console.error("Error cart check:", error));
    };

    checkCartForItems();

    document.addEventListener("DOMContentLoaded", function () {
        checkCartForItems();
    });
})();